module.exports = __webpack_public_path__ + "img/BE0404140107.247d109b.png";